import { SubCategoryRepository, UpdateSubCategoryInput } from '../../domain/repositories/sub-category.repository';
import { SubCategoryEntity } from '../../domain/entities/sub-category.entity';

export class UpdateSubCategoryUseCase {
  constructor(private readonly subCategoryRepository: SubCategoryRepository) {}

  async execute(id: string, input: UpdateSubCategoryInput): Promise<SubCategoryEntity> {
    return this.subCategoryRepository.updateSubCategory(id, input);
  }
}
